export default "__VITE_ASSET__a4d0ef05__"